import './deposit-modal.css'
import { useEffect, useState } from 'react'
import Modal from 'react-modal'
import QRCode from 'qrcode'

import { toast } from 'react-toastify'

import { useUser } from '../../context'
import { useAccount, useWalletClient } from 'wagmi'
import { parseUnits } from 'viem'
import { erc20Abi, USDC_ADDRESS, USDC_DECIMALS } from '../../constants'

const customStyles = {
	overlay: {
		backgroundColor: 'rgba(0, 0, 0, 0.7)',
		backdropFilter: 'blur(4px)',
		zIndex: 1000,
	},
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		background: '#1e1e1e',
		color: '#ffffff',
		borderRadius: '12px',
		padding: '24px',
		border: '1px solid #333',
		boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)',
		width: '90%',
		maxWidth: '600px',
	},
}

type ModalProps = {
	isOpen: boolean
	onRequestClose: () => void
	qrCodeAddress: string
}

export const DepositModal = ({
	isOpen,
	onRequestClose,
	qrCodeAddress,
}: ModalProps) => {
	const [qrLocation, setQrLocation] = useState('')
	const { address } = useAccount()
	const { data: walletClient } = useWalletClient()
	const { user } = useUser()
	const [processing, setProcessing] = useState(false)
	const [amount, setAmount] = useState('')

	useEffect(() => {
		QRCode.toDataURL(qrCodeAddress, { width: 180 })
			.then((url) => setQrLocation(url))
			.catch((err) => console.error(err))
	}, [])

	const handleDeposit = async () => {
		const test = parseFloat(amount)
		if (Number.isNaN(test)) {
			toast('Amount is not valid', {
				type: 'error',
			})
			return
		}

		if (!user?.dbInfo?.address) {
			toast('Connect with telegram first', {
				type: 'error',
			})
			return
		}

		if (!walletClient || !address) {
			toast('Wallet not connected', {
				type: 'error',
			})
			return
		}

		const depositAmount = parseUnits(amount, USDC_DECIMALS)

		try {
			setProcessing(true)
			// @ts-expect-error the function exists, the problem is with typings
			const hash = await walletClient.writeContract({
				address: USDC_ADDRESS,
				abi: erc20Abi,
				functionName: 'transfer',
				args: [user?.dbInfo?.address, depositAmount],
				account: address,
			})
			setAmount('')
			toast(`Deposit successful. TxHash: ${hash}`, {
				type: 'success',
			})
		} catch (error) {
			if (
				// @ts-expect-error: code may exist
				error?.code === 4001 ||
				// @ts-expect-error: message may exist
				error?.message?.includes('User rejected')
			) {
				toast('Transaction rejected by user.', { type: 'info' })
			} else {
				// @ts-expect-error: message may exist
				toast(error?.message || 'Transaction failed.', {
					type: 'error',
				})
			}
		} finally {
			setProcessing(false)
		}
	}

	const onClose = () => {
		if (processing) {
			return
		} else {
			onRequestClose()
		}
	}

	return (
		<Modal
			isOpen={isOpen}
			onRequestClose={onClose}
			style={customStyles}
			contentLabel="Deposit Modal"
		>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginBottom: '20px',
				}}
			>
				<h2 style={{ margin: 0, fontSize: '1.5rem' }}>
					Deposit to account
				</h2>
				<button
					onClick={onClose}
					style={{
						background: 'none',
						border: 'none',
						color: '#aaa',
						fontSize: '1.25rem',
						cursor: 'pointer',
					}}
				>
					×
				</button>
			</div>

			{/* Two Panels */}
			<div className="deposit-grid">
				{/* Left Panel */}
				<div style={{ flex: 1, paddingRight: '10px' }}>
					<p>Scan QR code below</p>
					<div
						style={{
							textAlign: 'center',
							marginTop: '20px',
							display: 'flex',
							justifyContent: 'center',
						}}
					>
						<div
							style={{
								padding: '10px',
								backgroundColor: 'white',
								borderRadius: '12px',
							}}
						>
							{qrCodeAddress ? (
								<img src={qrLocation} alt="QR Code" />
							) : (
								<p>Generating QR code...</p>
							)}
						</div>
					</div>
				</div>

				{/* Center Divider with "or" */}
				<div
					style={{
						position: 'relative',
						width: '40px',
						textAlign: 'center',
					}}
				>
					<div
						style={{
							position: 'absolute',
							left: '50%',
							top: 0,
							bottom: 0,
							transform: 'translateX(-50%)',
							width: '1px',
							backgroundColor: '#444',
						}}
					/>
					<span
						style={{
							position: 'absolute',
							background: '#1e1e1e',
							padding: '0 10px',
							color: '#aaa',
							left: 0,
							top: '40%',
						}}
					>
						or
					</span>
				</div>

				{/* Right Panel */}
				<div style={{ flex: 1, paddingLeft: '10px' }}>
					<p>Deposit with wallet</p>
					<input
						disabled={processing}
						type="number"
						placeholder="Enter amount"
						value={amount}
						onChange={(e) => setAmount(e.target.value)}
						style={{
							width: '100%',
							padding: '10px 14px',
							borderRadius: '8px',
							border: '1px solid #444',
							backgroundColor: '#2a2a2a',
							color: '#fff',
							marginTop: '10px',
							marginBottom: '10px',
							fontSize: '1rem',
						}}
					/>
					<button
						disabled={processing}
						onClick={handleDeposit}
						style={{
							width: '100%',
							padding: '12px',
							backgroundColor: '#4f46e5',
							color: '#fff',
							fontSize: '1rem',
							border: 'none',
							borderRadius: '8px',
							cursor: 'pointer',
						}}
					>
						{processing ? 'Processing...' : 'Deposit'}
					</button>
				</div>
			</div>
		</Modal>
	)
}
